document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.carousel-3d-wrapper');

    wrappers.forEach((wrapper) => {
        const ring = wrapper.querySelector('.carousel-3d-ring');
        const items = wrapper.querySelectorAll('.carousel-3d-item');
        const captionTitle = wrapper.querySelector('.carousel-3d-caption-title');
        const captionText = wrapper.querySelector('.carousel-3d-caption-text');
        const prevBtn = wrapper.querySelector('.carousel-3d-prev');
        const nextBtn = wrapper.querySelector('.carousel-3d-next');

        const totalSlides = items.length;
        const angleStep = 360 / totalSlides;
        const slideWidth = 360;
        const TIMER_DELAY = 4000;

        const tz = Math.round(
            (slideWidth / 1.8) / Math.tan(Math.PI / totalSlides)
        );
        ring.style.setProperty('--tz', `${tz}px`);

        let currentIndex = 0;
        let currentRotation = 0; // accumulateur en degrés
        let autoTimer = null;

        const updateCarousel = () => {
            ring.style.setProperty('--current-rotation', `${currentRotation}deg`);

            items.forEach((item, index) => {
                item.classList.toggle('is-active', index === currentIndex);
            });

            const activeItem = items[currentIndex];
            if (captionTitle) captionTitle.textContent = activeItem.dataset.title || '';
            if (captionText) captionText.textContent = activeItem.dataset.text || '';
        };

        const startTimer = () => {
            stopTimer();
            autoTimer = setInterval(() => {
                currentRotation -= angleStep;
                currentIndex = (currentIndex + 1) % totalSlides;
                updateCarousel();
            }, TIMER_DELAY);
        };

        const stopTimer = () => {
            if (autoTimer) {
                clearInterval(autoTimer);
                autoTimer = null;
            }
        };

        const handleUserInteraction = (direction) => {
            stopTimer();
            if (direction === 'next') {
                currentRotation -= angleStep;
                currentIndex = (currentIndex + 1) % totalSlides;
            } else {
                currentRotation += angleStep;
                currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
            }
            updateCarousel();
            setTimeout(startTimer, 8000);
        };

        nextBtn.addEventListener('click', () => handleUserInteraction('next'));
        prevBtn.addEventListener('click', () => handleUserInteraction('prev'));

        updateCarousel();
        startTimer();
    });
});